import { defineMessages } from 'react-intl';

const translations = {
  fields: {
    action: {
      label: {
        id: 'batchActionForm.action',
        defaultMessage: 'Action',
        description: 'label of the action field',
      },
    },
    batchReference: {
      label: {
        id: 'batchActionForm.batchReference',
        defaultMessage: 'Batch reference',
        description: 'label of the batch reference field',
      },
    },
    reference: {
      label: {
        id: 'batchActionForm.reference',
        defaultMessage: 'Reference',
        description: 'label of the reference field',
      },
    },
  },
  actions: {
    priceUpdate: {
      columns: {
        priceGroup: {
          id: 'batchActionForm.actions.priceUpdate.columns.priceGroup',
          defaultMessage: 'Price group',
          description: 'label of the price update action column price group id',
        },
        roundAmountAt: {
          id: 'batchActionForm.actions.priceUpdate.columns.roundAmountAt',
          defaultMessage: 'Round amount at',
          description: 'label of the price update action column round amount at',
        },
        activeAt: {
          id: 'batchActionForm.actions.priceUpdate.columns.activeAt',
          defaultMessage: 'Active at',
          description: 'label of the price update action column active at',
        },
      },
    },
    vatUpdate: {
      columns: {
        country: {
          id: 'batchActionForm.actions.vatUpdate.columns.country',
          defaultMessage: 'Country',
          description: 'label of the vat update action column country',
        },
        administrativeArea: {
          id: 'batchActionForm.actions.vatUpdate.columns.administrativeArea',
          defaultMessage: 'Administrative area',
          description: 'label of the vat update action column administrative area',
        },
        vatPercentage: {
          id: 'batchActionForm.actions.vatUpdate.columns.vatPercentage',
          defaultMessage: 'VAT percentage',
          description: 'label of the vat update action column vat percentage',
        },
      },
    },
    positionUpdate: {
      columns: {
        location: {
          id: 'batchActionForm.actions.positionUpdate.columns.location',
          defaultMessage: 'Location',
          description: 'label of the position update action column location',
        },
      },
    },
    stockUpdate: {
      columns: {
        location: {
          id: 'batchActionForm.actions.stockUpdate.columns.location',
          defaultMessage: 'Location',
          description: 'label of the stock update action column location',
        },
      },
    },
  },
};

export default defineMessages(translations);
